import Vue from 'vue';
import localization from '../localization';

/*
 * Convert timestamp dates to a text representation
 */

Vue.filter('time', (value: number) => {
    const date = new Date(value * 1000);

    return `${leadingZero(date.getHours())}:${leadingZero(date.getMinutes())}`;
});

Vue.filter('kpidate', (value: number) => {
    const val = value.toString();
    const year = val.slice(0, 4);
    const date = val.slice(4, 6);
    const ho = val.slice(6, 8);
    const min = val.slice(8, 10);
    return `<i>${date}-${year}</i><i>(${ho}:${min})</i>`;
});

Vue.filter('date', (value: number) => {
    const date = new Date(value * 1000);

    return formatDate(date);
});

Vue.filter('shortDate', (value: number) => {
    const date = new Date(value * 1000);

    return formatShortDate(date);
});

const minute = 1000 * 60;
const hour = minute * 60;
const day = hour * 24;
const month = day * 31;

/*
 *  Filter to display dates in a nicer way. Example: X days ago
 */

Vue.filter('fancyDate', (value: number) => {
    const date = new Date(value * 1000);
    const currentDate = new Date();

    const timeDifference = Date.now() - date.getTime();

    if(timeDifference < hour){
        const minuteDifference = Math.floor(timeDifference / minute);

        return localization.t('general.fancyDate.minute', { minutes: minuteDifference });
    } else if (timeDifference < day){
        const hourDifference = Math.floor(timeDifference / hour);

        return localization.t('general.fancyDate.hour', { hours: hourDifference });
    } else if(timeDifference < month){
        const dayDifference = Math.floor(timeDifference / day);

        return localization.t('general.fancyDate.day', { days: dayDifference });
    } else {
        return formatDate(date);
    }
});

const leadingZero = (num: number) => `0${num}`.slice(-2);

function formatDate(date: Date): string {
    return `${leadingZero(date.getDate())}-${leadingZero(date.getMonth() + 1)}-${date.getFullYear()} | ${leadingZero(date.getHours())}:${leadingZero(date.getMinutes())}`;
}

function formatShortDate(date: Date): string {
    return `${leadingZero(date.getDate())}-${leadingZero(date.getMonth() + 1)}-${date.getFullYear()}`;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/filters/date.ts